import { useCallback } from 'react'
import { useLatestLoad, type LoadStatus } from '../../hooks/useLatestLoad'
import type { RequestOptions } from '../../core/types/backend'

type Fetch<T> = (from: string, to: string, opts?: RequestOptions) => Promise<T>

export type Report<T> = { data: T | null; status: LoadStatus; reload: () => void }

/** Eén rapport voor de gekozen periode; een nieuwere periode breekt de oudere aanvraag af. */
export function useReport<T>(fetch: Fetch<T>, from: string, to: string): Report<T> {
  const load = useCallback((opts: RequestOptions) => fetch(from, to, opts), [fetch, from, to])
  const { data, status, reload } = useLatestLoad(load)
  return { data, status, reload }
}
